export default __webpack_public_path__ + "static/media/EM0690.34I-22669_-15170_0.fa0659f0.jpg";